class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.megaMenu = this.querySelector('.mega-menu');
    this.menuContent = this.querySelector('.mega-menu__content');
    
    if (this.megaMenu && this.menuContent) {
      this.megaMenu.addEventListener('mouseenter', () => this.openMenu());
      this.menuContent.addEventListener('mouseleave', () => this.closeMenu());

      const otherLinks = document.querySelectorAll('.header__menu-item:not(.mega-menu .header__menu-item)');
      otherLinks.forEach(link => {
        link.addEventListener('mouseenter', () => {
          this.closeMenu();
        });
      });
    }
  }

  openMenu() {
    if (!this.megaMenu) return;
    this.megaMenu.setAttribute('open', 'true');
    this.megaMenu.querySelector('summary').setAttribute('aria-expanded', 'true');
    if (this.header) this.header.preventHide = true;
  }

  closeMenu() {
    if (!this.megaMenu) return;
    this.megaMenu.removeAttribute('open');
    this.megaMenu.querySelector('summary').setAttribute('aria-expanded', 'false');
    if (this.header) this.header.preventHide = false;
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);